var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseEvent } from './base-event';
// tslint:disable:max-line-length
/**
 * Arguments for the `seriesClick` event.
 */
var SeriesClickEvent = /** @class */ (function (_super) {
    __extends(SeriesClickEvent, _super);
    // tslint:enable:max-line-length
    /**
     * @hidden
     */
    function SeriesClickEvent(e, target) {
        var _this = _super.call(this, target) || this;
        _this.category = e.category;
        _this.dataItem = e.dataItem;
        _this.nativeEvent = e.originalEvent;
        _this.percentage = e.percentage;
        _this.point = e.point;
        _this.series = e.series;
        _this.stackValue = e.stackValue;
        _this.value = e.value;
        return _this;
    }
    return SeriesClickEvent;
}(BaseEvent));
export { SeriesClickEvent };
//# sourceMappingURL=series-click-event.js.map